import { render } from "./AddonViewFullText.vue?vue&type=template&id=4739a0ab&scoped=true&ts=true"
import script from "./AddonViewFullText.vue?vue&type=script&lang=ts"
export * from "./AddonViewFullText.vue?vue&type=script&lang=ts"

import "./AddonViewFullText.vue?vue&type=style&index=0&id=4739a0ab&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4739a0ab"]])

export default __exports__